import { Redirect } from 'expo-router';

export default function ActivityRoute() {
  return <Redirect href="/(tabs)/activity" />;
}
